import { Outlet, useParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";
import QueryWrapper from "common/components/QueryWrapper";
import { PlayLayout } from "common/layouts/PlayLayout";
import { useGetGameQuery } from "quiz/api/games.endpoints";
import {
  DEFAULT_PSG_BACKGROUND_MOBILE,
  DEFAULT_WHITE_COLOR,
} from "../../_graphic_design";

export function GamePlayThemeWrapper() {
  const { gameId } = useParams();
  const getGameQuery = useGetGameQuery(gameId || skipToken);

  const defaultGameTheme = {
    colors: {
      background: "#131527",
      text: DEFAULT_WHITE_COLOR,
    },
    images: {
      playBackground: DEFAULT_PSG_BACKGROUND_MOBILE,
    },
  };

  return (
    <QueryWrapper query={getGameQuery}>
      {(game) => (
        <PlayLayout theme={game ? game.quizSnapshot : defaultGameTheme}>
          <Outlet />
        </PlayLayout>
      )}
    </QueryWrapper>
  );
}
